import { buttonStyle } from "../styles/HomeScreen.styles";
import { useHistory, Link, useLocation } from "react-router-dom";
import { PrimaryButton } from "@fluentui/react";
import PinInput from "react-pin-input";
import { FontSizes, FontWeights } from "@fluentui/theme";
import { useGlobalState } from "../utils/GlobalState";
import React from "react";
import { SchoolService } from "../services/school.service";
import pdf from "../assets/Finalised Exams_Info for Students Staff 2023.pdf";

export const SignInButton = () => {
  const history = useHistory();
  const { state } = useGlobalState();
  const [errors, setErrors] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState("");
  const [pins, setPins] = React.useState("");
  const schoolService = new SchoolService();
  const [disabledState, setDisabledState] = React.useState(true);

  const acsHelperRoute = () => {
    setErrors(false);
    setErrorMessages("");

    var id = localStorage.getItem("meetingId");

    if (id) {
      schoolService.validate(id, pins).then((result) => {
        if (result.success === true) {
          localStorage.setItem("accessToken", result.accessToken);

          history.push("/StudentDetails");
        } else {
          setErrors(true);
          setErrorMessages("Unable to login");
        }
      });
    } else {
      setErrors(true);
      setErrorMessages("Unable to find meeting details");
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div>
          <div
            style={{
              fontSize: FontSizes.size42,
              textAlign: "center",
              fontWeight: FontWeights.bold,
            }}
          >
            Welcome to HSC Language Oral Exams
          </div>
          <div>
            <div
              style={{
                fontSize: FontSizes.size32,
                marginTop: 50,
                fontWeight: FontWeights.semibold,
              }}
            >
              Instructions{" "}
            </div>
            <ol>
              <li
                style={{
                  fontSize: FontSizes.size20,
                  fontWeight: FontWeights.regular,
                }}
              >
                Once you have entered the PIN below the student will be taken to
                the exam room.
              </li>
              <li
                style={{
                  fontSize: FontSizes.size20,
                  fontWeight: FontWeights.regular,
                }}
              >
                When entering the room please accept the audio and camera
                options if they appear.
              </li>
              <li
                style={{
                  fontSize: FontSizes.size20,
                  fontWeight: FontWeights.regular,
                }}
              >
                The student will be able to see and hear the examiner at this
                time.
              </li>
              <li
                style={{
                  fontSize: FontSizes.size20,
                  fontWeight: FontWeights.regular,
                }}
              >
                The exam recording will commence after the examiner has tested
                the sound and completed an identity check.
              </li>
              <li
                style={{
                  fontSize: FontSizes.size20,
                  fontWeight: FontWeights.regular,
                }}
              >
                At the end of the exam the recording will be uploaded and the
                student will leave the virtual room – there will be no audio
                played back.
              </li>
              <li
                style={{
                  fontSize: FontSizes.size20,
                  fontWeight: FontWeights.regular,
                }}
              >
                If you have another student, close this browser and open a new
                browser to join the next exam with the link and PIN provided.
              </li>
            </ol>
          </div>
          <div
            style={{
              textAlign: "center",
              fontSize: FontSizes.size32,
              marginBottom: 30,
              marginTop: 30,
              fontWeight: FontWeights.semibold,
            }}
          >
            Enter your PIN from the email to begin:
          </div>
        </div>
        <div>
          <PinInput
            length={6}
            initialValue=""
            // secret
            onChange={(value, index) => {}}
            type="numeric"
            inputMode="number"
            style={{ padding: "10px" }}
            inputStyle={{ borderColor: "red" }}
            inputFocusStyle={{ borderColor: "blue" }}
            onComplete={(value, index) => {
              setPins(value);
              setDisabledState(false);
            }}
            autoSelect={true}
            regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
          />
        </div>
        <div
          style={{
            marginTop: 30,
            marginBottom: 30,
          }}
        >
          <PrimaryButton
            onClick={acsHelperRoute}
            className={buttonStyle}
            disabled={disabledState}
          >
            Sign In
          </PrimaryButton>
        </div>
        {errors ? <div style={{ color: "red" }}>Error occurred</div> : null}
        {errorMessages ? (
          <div style={{ color: "red" }}>{errorMessages}</div>
        ) : null}

        <div
          style={{
            textAlign: "center",
            fontSize: FontSizes.size20,
            marginBottom: 30,
            marginTop: 30,
            fontWeight: FontWeights.regular,
          }}
        >
          <a href={pdf} target="_blank">
            Technical Support information
          </a>
        </div>
      </div>
    </>
  );
};
